import { VFileInput } from 'vuetify/lib/components/VFileInput';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFileInput,_vm._b({attrs:{"outlined":"","hide-details":"auto","label":_vm.$t('Import file'),"prepend-icon":"mdi-file"},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}},'v-file-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }